import styles from './Footer.module.css'

function Footer() {
    return (
        <footer className={styles.footer}>
            <p>
                <span className="bold">CETA Sistemas</span> &copy; 2015
            </p>
        </footer>
    )
    
}

export default Footer